// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TONa3","left":"styles_left__mgSZg","right":"styles_right__1hF9m","alert":"styles_alert__3WZbU"};